import type { CustomAttributeData } from '@risksmart-app/domain/src/types/common.types';
import type {
  Action_Status_Enum,
  InputMaybe,
  InsertChildActionMutation,
} from '@risksmart-app/web-graphql-client/generated/graphql';
import {
  InsertChildActionDocument,
  namedOperations,
} from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

export interface InsertChildActionInput {
  Title: string;
  DateDue: string;
  DateRaised: string;
  Status: Action_Status_Enum;
  ParentId?: InputMaybe<string>;
  Priority?: InputMaybe<number>;
  Description?: InputMaybe<string>;
  ClosedDate?: InputMaybe<string>;
  CustomAttributeData?: InputMaybe<CustomAttributeData>;
  OwnerUserIds: string[];
  OwnerGroupIds: string[];
  ContributorUserIds: string[];
  ContributorGroupIds: string[];
  ViewerUserIds?: InputMaybe<string[]>;
  ViewerGroupIds?: InputMaybe<string[]>;
  TagTypeIds: string[];
  DepartmentTypeIds: string[];
}

export const useInsertChildAction = createMutationHook({
  name: 'insertChildAction',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.action.insert.mutationOptions({ onSuccess }),
  mapInput: (input: InsertChildActionInput) => input,
  invalidate: (trpc) => [
    trpc.frontend.action.register.queryKey(),
    trpc.frontend.action.actionById.queryKey(),
    // COI-889: the internal-audit register carries open/closed-action count
    // columns, and the consumer evicts `internal_audit_entity` on Apollo.
    trpc.frontend.internalAuditEntity.pathKey(),
    // COI-889: the my-items ribbon counts this entity.
    trpc.frontend.myItems.pathKey(),
  ],
  mapResponse: (result: { Id: string }): InsertChildActionMutation => ({
    insertChildAction: {
      __typename: 'IdOutput',
      Id: result.Id,
    },
  }),
  graphqlDocument: InsertChildActionDocument,
  graphqlVariables: (input: InsertChildActionInput) => ({ ...input }),
  evictFields: ['action', 'action_aggregate'],
  refetchQueries: [namedOperations.Query.getActionById],
});
